import axios from 'axios'
// let host = 'http://127.0.0.1:8080'
// let host = 'http://34.75.244.185'
// let host = 'https://www.warmmachine.org'
// let host = 'http://0.0.0.0'
// let host = 'http://127.0.0.1:8080/api'
let host = ''

//Get Domains
export const getDomains = params => {
  if ('domain_name' in params){
    return axios.get(`${host}/api/domain_detail/` + params.domain_name + '/')
  }
  else{
    return axios.get(`${host}/api/domain/`);
  }
}

export const getCourses = params => {
  if ('id' in params){
    return axios.get(`${host}/api/course_detail/` + params.id + '/');
  }
}

export const getInstructor = params => {
  if ('id' in params){
    return axios.get(`${host}/api/instructor_detail/` + params.id + '/');
  }
}

export const getInstructorOverview = params => {
  return axios.get(`${host}/api/instructor_overview/`, {params: params})
}

export const getSyllabus = params => {
  if ('id' in params){
    return axios.get(`${host}/api/syllabus/` + params.id + '/')
  }
}

export const getProvider = params => {
  if ('id' in params){
    return axios.get(`${host}/api/provider/` + params.id + '/')
  }
  //error handling
}

export const getSearch = params => {
  if (params){
    return axios.get(`${host}/api/course_overview/`, {params: params})
  }
  else{
    return axios.get(`${host}/api/course_overview/`)
  }
}

export const getSuggestedCourse = params => {
  return axios.get(`${host}/api/course_suggested/`, {params: params})
}

export const getFuzzySuggestedCourse = params => {
  return axios.get(`${host}/api/course_fuzzy/`, {params: params})
}

export const getCourseDisplay = params => {
  if ('id' in params) {
    return axios.get(`${host}/api/course_display/` + params.id + '/')
  }
}

export const getDomainCourseCount = params => {
  return axios.get(`${host}/api/domain_agg/`, {params: params})
}

export const getPlatformCourseCount = params => {
  return axios.get(`${host}/api/platform_agg/`, {params: params})
}

export const getLanguageCourseCount = params => {
  return axios.get(`${host}/api/language_agg/`, {params: params})
}

export const createBugReport = params => {
  return axios.post(`${host}/api/report_bug/`, params)
}

export const createSuggestion = params => {
  return axios.post(`${host}/api/suggestion/`, params)
}


export const createNewCourse = params => {
  return axios.post(`${host}/api/new_course/`, params)
}


export const createSubscribedUser = params => {
  return axios.post(`${host}/api/subscription/`, params)
}

export const gotoCourse = params => {
  return axios.post(`${host}/api/gotocourse/`, params)
}

// concept map part
export const getSmallMapData = params => {
  return axios.get(`${host}/api/concept_map_dagre/` + params.id + '/')
}

export const getConceptOverview = params => {
  return axios.get(`${host}/api/concept_overview/` + params.id + '/')
}

export const getConceptPreAdv = params => {
  return axios.get(`${host}/api/concept_pre_adv/` + params.id + '/')
}

export const getConceptSearchResult = params => {
  return axios.get(`${host}/api/concept_search/`, {params: params})
}

export const getSuggestedConcept = params => {
  return axios.get(`${host}/api/concept_suggest/`, {params: params})
}

export const getConceptPre = params => {
  return axios.get(`${host}/api/concept_pre/` + params.id + '/')
}

export const getGoalConceptCurriculum = params => {
  return axios.get(`${host}/api/concept_curriculum/` + params.id + '/', {params: params})
}

// operations
export const keepGate = params => {
  return axios.get(`${host}/gate_keeper/`, {params: params})
}



// WEBPACK FOOTER //
// ./src/api/api.js